<section class="p-0">
  @if (currentSnapshot) {
    <div class="task-log-diff-section__summary">
      <div class="task-log-diff-field">
        <span class="task-log-diff-field__label" i18n>Statut</span>
        <span
          [ngClass]="{
            'new-lead-value': isChanged(
              currentSnapshot.status,
              baselineSnapshot?.status
            ),
          }"
        >
          {{ getLeadStatusLabel(currentSnapshot.status) }}
        </span>
        @if (
          baselineSnapshot?.status &&
          isChanged(currentSnapshot.status, baselineSnapshot?.status)
        ) {
          <span class="old-lead-value">{{
            getLeadStatusLabel(baselineSnapshot?.status)
          }}</span>
        }
      </div>
    </div>

    <app-task-log-metadata-diff
      [insuranceType]="currentSnapshot.insuranceType"
      [leadId]="currentSnapshot.leadId"
      [memberId]="currentSnapshot.memberId"
      [userId]="currentSnapshot.userId"
      [metadata]="currentSnapshot.metadata"
      [baselineMetadata]="baselineSnapshot?.metadata"
      [baselineLeadId]="baselineSnapshot?.leadId"
      [baselineMemberId]="baselineSnapshot?.memberId"
      [baselineUserId]="baselineSnapshot?.userId"
    />
  } @else {
    <div class="text-muted" i18n>Non disponible</div>
  }
</section>
